import gql from 'graphql-tag';

export const edit = gql`mutation EditCurrency($id: ID!, $currency: CurrencyInput!) {
    editCurrency(id: $id, currency: $currency) {
        id
        name
        isoCode
        symbol
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/currency.js